import { createFileRoute } from "@tanstack/react-router";
import ChecklistGuide from "@/pages/ghiduri/ChecklistGuide";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/ghiduri/checklist-cumparare-masina-second-hand/")({
  head: () => routeHead("/ghiduri/checklist-cumparare-masina-second-hand/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ChecklistGuide />
  );
}
